<div class="device-imei">
  <h1 class="margin-bottom-medium">Finding your IMEI number</h1>
  <p>The IMEI number is a unique 15-digit serial number specific to your phone.</p>
  <p class="margin-bottom-large">Finding your IMEI number is simple: just click 'Get IMEI Number' below. Once it appears, take a screenshot of the IMEI as you'll need it for the next step.</p>
  <div class="open-form-info padding-medium margin-bottom-large">
    Taking a screenshot may differ per device but generally its the same or similar process on most device.
  </div>
  <div class="margin-bottom-large">
    <img *ngIf="oS === 'iPhone'" src="https://placehold.co/200x200?text=iPhone" width="200" height="200" />
    <img *ngIf="oS === 'Android'" src="https://placehold.co/200x200?text=Android" width="200" height="200" />
  </div>
  <div class="device-flow-controls">
    <button (click)="getImeiAction()" mat-flat-button color="secondary" class="margin-bottom-medium device-imei-action">Get IMEI Number</button>
    <button mat-flat-button color="primary" class="device-imei-action" [disabled]="!getImeiClicked">Continue</button>
  </div>
</div>